var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","min-height":"0"}},[_c('textarea',{ref:"txt"})])
}
var staticRenderFns = []

export { render, staticRenderFns }